import { Component } from '@angular/core';
import { app, analytics } from './firebase-config';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'yogamez-frontend';
  constructor() {
  }

}

